// extracted by mini-css-extract-plugin
module.exports = {"header":"featured-articles_header__WOaZG","subHeader":"featured-articles_subHeader__B45yt","featuredArticlesContainer":"featured-articles_featuredArticlesContainer__anZhn"};